import { render, staticRenderFns } from "./QuestionFormDialog.vue?vue&type=template&id=60b15a6a&"
import script from "./QuestionFormDialog.vue?vue&type=script&lang=ts&"
export * from "./QuestionFormDialog.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionFormDialog.vue?vue&type=style&index=0&id=60b15a6a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports